// extracted by mini-css-extract-plugin
export default {"header":"_1ZKBZ","entryName":"_3ZcGe","stakeName":"_325X_","matchName":"_1f5Mv","nameError":"_1xNeY","errorMessage":"WpCYU","removeEntryButton":"_3KbvL","datetime":"_3RbcD"};